import { FC, useEffect, useState } from "react";
import BotLogo from "../../../assets/images/bot-logo.svg";
import { Box, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useNavigate } from "react-router-dom";
import AirHorn from "../../../assets/images/air-horn 1.png";
import Celebrate from "../../../assets/images/celebrate.gif";
import { CustomButton } from "../../../components/Button";

const currentYear = new Date().getFullYear();

const VerificationConfirm: FC = () => {
  const navigate = useNavigate();
  const [seconds, setSeconds] = useState(5);

  useEffect(() => {
    if (seconds === 0) {
      navigate("/signin");
    }
    const interval = setInterval(() => {
      setSeconds((prev) => prev - 1);
    }, 1000);
    const elem = document.getElementById("root");
    if (elem) {
      elem.style.backgroundImage = `url(${Celebrate})`;
    }
    return () => {
      if (elem) {
        elem.style.backgroundImage = "";
      }
      clearInterval(interval);
    };
  }, [seconds]);

  return (
    <>
      <Box
        sx={{
          flex: 1,
          display: "flex",
          justifyContent: "center",
          //   alignItems: "center",
          marginTop: "30px",
        }}
      >
        <img src={BotLogo} alt="Logo" className="bot-logo" />
        <Grid
          container
          spacing={2}
          direction="column"
          alignItems="center"
          //   justifyContent="center"
        >
          <img src={AirHorn} style={{ width: "230px", height: "230px" }} />
          <Typography color="#111">Yayy! Email Verified</Typography>
          <CustomButton text={`Redirecting in ( ${seconds} )`} disabled />
        </Grid>
      </Box>
      <div className="copyright-div">
        <Typography className="copyright">
          © {currentYear} ALL RIGHTS RESERVED
        </Typography>
      </div>
    </>
  );
};

export default VerificationConfirm;
